module.exports = __webpack_public_path__ + "static/img/kv.04e94e65.png";